import React from 'react';

import ComingSoon from '../../ComingSoon';

export const ClassDetailInsights = () => (
    <>
        <ComingSoon></ComingSoon>
    </>
);
